import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Text } from './Text'

const FooterContainer = styled.footer`
  background: rgba(10, 10, 10, 0.8);
  backdrop-filter: blur(10px);
  padding: 3rem 2rem;
  margin-top: 4rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }
`

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;

  @media (max-width: 768px) {
    justify-content: center;
  }

  a {
    color: #ffffff;
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 0.5rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;

    &:hover {
      background: #4ecdc4;
      transform: translateY(-3px);
    }
  }
`

const Copyright = styled.div`
  text-align: center;
  padding-top: 2rem;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #a0a0a0;
  font-size: 0.9rem;
`

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <FooterContainer role='contentinfo'>
      <FooterContent>
        <FooterSection>
          <Text
            text='Mr. Zee'
            fontSize='1.5rem'
            fontWeight='bold'
            color='#ffffff'
            role='heading'
            aria-level={2}
          />
          <Text
            text='Full Stack Developer specializing in modern web technologies and user-centric applications.'
            fontSize='1rem'
            color='#a0a0a0'
            role='doc-subtitle'
          />
        </FooterSection>

        <FooterSection>
          <Text
            text='Connect'
            fontSize='1.2rem'
            fontWeight='bold'
            color='#ffffff'
            role='heading'
            aria-level={3}
          />
          <SocialLinks>
            <a
              href='https://github.com/dzirmal'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='GitHub'>
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='currentColor'>
                <path d='M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z' />
              </svg>
            </a>
            <a
              href='https://linkedin.com/in/dzirmal'
              target='_blank'
              rel='noopener noreferrer'
              aria-label='LinkedIn'>
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='currentColor'>
                <path d='M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z' />
              </svg>
            </a>
            <a href='mailto:contact@dzirmal.com' aria-label='Email'>
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='currentColor'>
                <path d='M0 3v18h24v-18h-24zm21.518 2l-9.518 7.713-9.518-7.713h19.036zm-19.518 14v-11.817l10 8.104 10-8.104v11.817h-20z' />
              </svg>
            </a>
          </SocialLinks>
        </FooterSection>

        <FooterSection>
          <Text
            text='Quick Links'
            fontSize='1.2rem'
            fontWeight='bold'
            color='#ffffff'
            role='heading'
            aria-level={3}
          />
          <nav>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '0.5rem' }}>
                <Link
                  to='/'
                  style={{
                    color: '#a0a0a0',
                    textDecoration: 'none',
                    transition: 'color 0.3s ease',
                  }}>
                  Home
                </Link>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <Link
                  to='/projects'
                  style={{
                    color: '#a0a0a0',
                    textDecoration: 'none',
                    transition: 'color 0.3s ease',
                  }}>
                  Projects
                </Link>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>
                <Link
                  to='/skills'
                  style={{
                    color: '#a0a0a0',
                    textDecoration: 'none',
                    transition: 'color 0.3s ease',
                  }}>
                  Skills
                </Link>
              </li>
              <li>
                <Link
                  to='/contact'
                  style={{
                    color: '#a0a0a0',
                    textDecoration: 'none',
                    transition: 'color 0.3s ease',
                  }}>
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </FooterSection>
      </FooterContent>

      <Copyright>
        <Text
          text={`© ${currentYear} Dzirmal. All rights reserved.`}
          fontSize='0.9rem'
          color='#a0a0a0'
        />
      </Copyright>
    </FooterContainer>
  )
}
